/**
 * @generated SignedSource<<65de17a3a0c4068a7975f9fce863c7c7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type KudosDirectoryQuery$variables = {
  workspaceId: string;
};
export type KudosDirectoryQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"KudosDirectoryContent_data">;
};
export type KudosDirectoryQuery = {
  response: KudosDirectoryQuery$data;
  variables: KudosDirectoryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "workspaceId"
  }
],
v1 = {
  "kind": "Variable",
  "name": "workspaceId",
  "variableName": "workspaceId"
},
v2 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 12
  },
  {
    "kind": "Literal",
    "name": "q",
    "value": ""
  },
  (v1/*: any*/)
],
v3 = {
  "kind": "ScalarField",
  "name": "name"
},
v4 = {
  "kind": "ScalarField",
  "name": "picture"
},
v5 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "KudosDirectoryQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "KudosDirectoryContent_data"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "KudosDirectoryQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "KudosConnection",
        "kind": "LinkedField",
        "name": "kudosTql",
        "plural": false,
        "selections": [
          {
            "concreteType": "KudosEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "Kudos",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "uuid"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "ari"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "description"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "imageUrl"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "stillImageUrl"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "type"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "bgTheme"
                  },
                  {
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "giver",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "UserPII",
                        "kind": "LinkedField",
                        "name": "pii",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/)
                        ]
                      },
                      (v6/*: any*/)
                    ]
                  },
                  {
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1
                      }
                    ],
                    "concreteType": "KudosRecipientConnection",
                    "kind": "LinkedField",
                    "name": "recipients",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "KudosRecipientEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "KudosRecipient",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "User",
                                "kind": "LinkedField",
                                "name": "recipient",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "UserPII",
                                    "kind": "LinkedField",
                                    "name": "pii",
                                    "plural": false,
                                    "selections": [
                                      (v5/*: any*/),
                                      (v3/*: any*/),
                                      (v4/*: any*/)
                                    ]
                                  },
                                  (v6/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "Team",
                                "kind": "LinkedField",
                                "name": "team",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "teamId"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "avatarUrl"
                                  },
                                  (v6/*: any*/)
                                ]
                              },
                              (v6/*: any*/)
                            ]
                          }
                        ]
                      }
                    ],
                    "storageKey": "recipients(first:1)"
                  },
                  (v6/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "endCursor"
              },
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              }
            ]
          }
        ]
      },
      {
        "args": (v2/*: any*/),
        "filters": [
          "q",
          "workspaceId"
        ],
        "handle": "connection",
        "key": "KudosDirectoryContent_kudosTql",
        "kind": "LinkedHandle",
        "name": "kudosTql"
      }
    ]
  },
  "params": {
    "cacheID": "a930db735e74b144c5b2120829885391",
    "id": null,
    "metadata": {},
    "name": "KudosDirectoryQuery",
    "operationKind": "query",
    "text": "query KudosDirectoryQuery(\n  $workspaceId: ID!\n) {\n  ...KudosDirectoryContent_data_26wvsp\n}\n\nfragment KudosContent on Kudos {\n  uuid\n  ari\n  description\n  imageUrl\n  stillImageUrl\n  type\n  bgTheme\n  giver {\n    pii {\n      name\n      picture\n      accountId\n    }\n    id\n  }\n  recipients(first: 1) {\n    edges {\n      node {\n        recipient {\n          pii {\n            accountId\n            name\n            picture\n          }\n          id\n        }\n        team {\n          name\n          teamId\n          avatarUrl\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment KudosDirectoryContent_data_26wvsp on Query {\n  kudosTql(q: \"\", workspaceId: $workspaceId, first: 12) {\n    edges {\n      node {\n        ...KudosContent\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "caa56712abde05627223eb70f733301a";

export default node;
